import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  FormGroup,
  Grid,
  MenuItem,
  Paper,
  TextField,
  Autocomplete
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { MAIN_URL } from "../../../Configurations/Urls";
import useAuthStore from "../../../Zustand/Store/useAuthStore";
import axios from "axios";
import toast from "react-hot-toast";
import Header from "../../DataLayouts/Header";

function ProjectTaskTemplateForm() {

const complexityOptions = ["Low", "Medium", "High", "Expert"];
  const navigate = useNavigate();
  const { id } = useParams(); // if id is present => edit mode
  const mode = id ? "edit" : "add";


  const { userData } = useAuthStore();

  console.log("full uer data is : ", userData);

  const org = userData?.organization;
  console.log("org?.organization_id is : ", org?.organization_id);

  const fetchTaskTemplates = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${MAIN_URL}/api/project-management/project-task-template/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = res.data?.data;
      if (data) {
        setFormData({
          organization_id: data.organization_id || "",
          organization_entity_id: data.organization_entity_id || "",
          organization_project_task_category_id: data.organization_project_task_category_id || "",
          organization_project_task_subcategory_id: data.organization_project_task_subcategory_id || "",
          task_title: data.task_title || "",
          description: data.description || "",
          complexity_level: data.complexity_level || "",
          task_instructions: data.task_instructions || "",
          applicable_organization_designation_id: data.applicable_organization_designation_id || "",
          estimated_minutes: data.estimated_minutes || "",
          is_task_time_quantity_based: data.is_task_time_quantity_based || false,
          quantity_unit: data.quantity_unit || "",
          is_active: data.is_active || false
        });
      }
    } catch (error) {
      toast.error("Failed to fetch task template data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (mode === "edit" && id) {
      fetchTaskTemplates();
    }
  }, [mode, id]);

  const [formData, setFormData] = useState({
    organization_id: org?.organization_id || "",
    organization_project_task_category_id: "",
    organization_project_task_subcategory_id: "",
    organization_entity_id: "",
    task_title: "",
    description: "",
    complexity_level: "",
    task_instructions: "",
    applicable_organization_designation_id: "",
    estimated_minutes: "",
    is_task_time_quantity_based: false,
    quantity_unit: "",
    is_active: false
  });

  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);

  const validateForm = () => {
    const errors = {};

    if (!formData.task_title?.trim())
      errors.task_title = "Task title is required";

    if (!formData.organization_project_task_category_id)
      errors.organization_project_task_category_id = "Task Category is required";

    if (formData.task_title?.trim()?.length > 150)
      errors.task_title = "Max 150 Characters allowed";

    if (formData.description?.trim() && formData.description?.trim()?.length > 255)
      errors.description = "Max 255 Characters Allowed";

    if (formData.estimated_minutes && Number(formData.estimated_minutes) <= 0) {
      errors.estimated_minutes = "Allocated minutes must be greater than 0";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };


  const [selectOptions, setSelectOptions] = useState({
    Designations: [],
    Categories: [],
    SubCategories: [],
  })

  const fetchDesignations = async () => {
    try {
      const response = await axios.get(`${MAIN_URL}/api/organizations/${org?.organization_id}/designation/v1`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          per_page: "all",
          organization_id: org?.organization_id,
        },
      });

      setSelectOptions((prev) => ({ ...prev, Designations: response.data.data }));
    } catch (e) {
      console.error("Failed to load project Designations");
    }
  };

  const fetchProjectTaskCategories = async () => {
    try {
      const response = await axios.get(`${MAIN_URL}/api/project-management/project-task-category`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          per_page: "all",
          organization_id: org?.organization_id,
        },
      });

      console.log("response Categories is : ", response);

      setSelectOptions((prev) => ({ ...prev, Categories: response.data.data }));
    } catch (e) {
      console.error("Failed to load Categories");
    }
  };

  const fetchProjectTaskSubCategories = async (category_id) => {
    try {
      const response = await axios.get(`${MAIN_URL}/api/project-management/project-task-sub-category`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          per_page: "all",
          organization_id: org?.organization_id,
          category_id
        },
      });

      console.log("response SubCategories is : ", response);

      setSelectOptions((prev) => ({ ...prev, SubCategories: response.data.data }));
    } catch (e) {
      console.error("Failed to load SubCategories");
    }
  };

  useEffect(() => {
    fetchDesignations();
    fetchProjectTaskCategories();
  }, [org?.organization_id]);

  useEffect(() => {
    if (formData?.organization_project_task_category_id) {
      fetchProjectTaskSubCategories(formData?.organization_project_task_category_id);
    }
  }, [formData?.organization_project_task_category_id]);


  // Submit form
  const handleSubmit = async () => {
    setFormErrors({});

    if (!validateForm()) {
      toast.error("Please fix the validation errors.");
      return;
    }

    let organization_entity_id = userData?.organization?.
      entities?.organization_entity_id || null;
    console.log("organization_entity_id is : ", organization_entity_id);

    setBtnLoading(true);
    try {
      const token = localStorage.getItem("token");


      if (mode === "edit") {
        await axios.put(`${MAIN_URL}/api/project-management/project-task-template/${id}`, { ...formData, organization_entity_id }, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        toast.success("Task Template updated");
      } else {
        await axios.post(`${MAIN_URL}/api/project-management/project-task-template`, { ...formData, organization_entity_id }, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        toast.success("Task Template added");
      }

      navigate("/project-task-template");
    } catch (err) {
      if (err.response?.status === 422) {
        toast.error("Please fix the validation errors.");
        setFormErrors(err.response.data.errors);
      } else {
        toast.error("Operation failed");
      }
    }
    setBtnLoading(false);
  };


  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setFormErrors((prev) => ({ ...prev, [name]: "" }));
  };



  return (
    <Box px={4} py={4}>
      <Header
        mode={mode}
        updateMessage={"Task Templates"}
        addMessage={"Task Templates"}
        homeLink={"/project-task-template"}
        homeText={"Task Templates"}
      />

      {loading ? (
        <Box display="flex" justifyContent="center" py={4}>
          <CircularProgress />
        </Box>
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12} md={8}>
            <Paper elevation={4} sx={{ p: 3 }}>
              <Grid container spacing={2}>

                <TextField
                  fullWidth
                  label="Task Title *"
                  name="task_title"
                  value={formData.task_title}
                  onChange={handleChange}
                  error={!!formErrors.task_title}
                  helperText={formErrors.task_title}
                />

             

<Autocomplete
  fullWidth
  options={selectOptions.Categories || []}
  getOptionLabel={(option) => option.task_category_name || ""}
  value={
    selectOptions.Categories?.find(
      (cat) =>
        cat.organization_project_task_category_id ===
        formData.organization_project_task_category_id
    ) || null
  }
  onChange={(event, newValue) => {
    setFormData((prev) => ({
      ...prev,
      organization_project_task_category_id:
        newValue?.organization_project_task_category_id || "",
    }));
  }}
  isOptionEqualToValue={(option, value) =>
    option.organization_project_task_category_id ===
    value.organization_project_task_category_id
  }
  renderInput={(params) => (
    <TextField
      {...params}
      label="Project Task Category *"
      error={!!formErrors.organization_project_task_category_id}
      helperText={formErrors.organization_project_task_category_id}
    />
  )}
/>



<Autocomplete
  fullWidth
  disabled={selectOptions.SubCategories.length === 0}
  options={selectOptions.SubCategories || []}
  getOptionLabel={(option) => option.task_subcategory_name || ""}
  value={
    selectOptions.SubCategories.find(
      (cat) =>
        cat.organization_project_task_subcategory_id ===
        formData.organization_project_task_subcategory_id
    ) || null
  }
  onChange={(event, newValue) => {
    setFormData((prev) => ({
      ...prev,
      organization_project_task_subcategory_id:
        newValue?.organization_project_task_subcategory_id || "",
    }));
  }}
  isOptionEqualToValue={(option, value) =>
    option.organization_project_task_subcategory_id ===
    value.organization_project_task_subcategory_id
  }
  renderInput={(params) => (
    <TextField
      {...params}
      label="Project Task Sub Category"
      error={!!formErrors.organization_project_task_subcategory_id}
      helperText={
        selectOptions.SubCategories.length === 0
          ? "No SubCategories Available For This Category"
          : formErrors.organization_project_task_subcategory_id
      }
    />
  )}
/>




                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  label="Task Description "
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  error={!!formErrors.description}
                  helperText={formErrors.description}
                />


<Autocomplete
  fullWidth
  options={complexityOptions}
  value={formData.complexity_level || null}
  onChange={(event, newValue) => {
    setFormData((prev) => ({
      ...prev,
      complexity_level: newValue || "",
    }));
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      label="Complexity"
      error={!!formErrors.complexity_level}
      helperText={formErrors.complexity_level}
    />
  )}
/>


               
<Autocomplete
  fullWidth
  options={selectOptions?.Designations || []}
  getOptionLabel={(option) => option.designation_name || ""}
  value={
    selectOptions?.Designations?.find(
      (d) =>
        d.organization_designation_id ===
        formData.applicable_organization_designation_id
    ) || null
  }
  onChange={(event, newValue) => {
    setFormData((prev) => ({
      ...prev,
      applicable_organization_designation_id:
        newValue?.organization_designation_id || "",
    }));
  }}
  isOptionEqualToValue={(option, value) =>
    option.organization_designation_id === value.organization_designation_id
  }
  renderInput={(params) => (
    <TextField
      {...params}
      label="Applicable Designation"
      error={!!formErrors.applicable_organization_designation_id}
      helperText={formErrors.applicable_organization_designation_id}
    />
  )}
/>



                <TextField
                  fullWidth
                  type="number"
                  label="Estimated Time Minutes "
                  name="estimated_minutes"
                  value={formData.estimated_minutes}
                  onChange={handleChange}
                  error={!!formErrors.estimated_minutes}
                  helperText={formErrors.estimated_minutes}
                  inputProps={{ min: 0 }}
                />


                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="is_task_time_quantity_based"
                        checked={formData.is_task_time_quantity_based}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            is_task_time_quantity_based: e.target.checked,
                          })
                        }
                      />
                    }
                    label="Is time depends upon Quantity "
                  />
                </FormGroup>


                <TextField
                  fullWidth
                  disabled={!formData.is_task_time_quantity_based}
                  type="text"
                  label="Quanity Unit "
                  name="quantity_unit"
                  value={formData.quantity_unit}
                  onChange={handleChange}
                  error={!!formErrors.quantity_unit}
                  helperText={formErrors.quantity_unit}
                  inputProps={{ min: 0 }}
                />


                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  label="Task Instructions "
                  name="task_instructions"
                  value={formData.task_instructions}
                  onChange={handleChange}
                  error={!!formErrors.task_instructions}
                  helperText={formErrors.task_instructions}
                />

              </Grid>
              <Button
                variant="contained"
                color="primary"
                size="medium"
                onClick={handleSubmit}
                disabled={loading || btnLoading}
                sx={{
                  borderRadius: 2,
                  minWidth: 120,
                  textTransform: "capitalize",
                  fontWeight: 500,
                  mt: 2
                }}
              >
                {loading || btnLoading ? (
                  <CircularProgress size={22} sx={{ color: "#fff" }} />
                ) : mode === "edit" ? (
                  "Update"
                ) : (
                  "Submit"
                )}
              </Button>

            </Paper>
          </Grid>
        </Grid>
      )}

    </Box>
  )
}

export default ProjectTaskTemplateForm